module.exports = __webpack_public_path__ + "static/assets/def4ae3ead77dbb59ac95db391a1e8ad.svg";